"use client";

import React from "react";
import { OpeningsLogo } from "./OpeningsLogo";

function PoweredByOpenings() {
  return (
    <a
      href="https://www.openings.link"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Powered by Openings"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        textDecoration: "none",
      }}
    >
      <OpeningsLogo size={18} />
      <span style={{ fontSize: 12, color: "rgba(0,0,0,0.45)" }}>
        Powered by Openings
      </span>
    </a>
  );
}

export default PoweredByOpenings;
